/**
 * wire-comments entry. Renders canned threads under front-page stories
 * and a posting form that "works". Exposes window.__wire.comments for
 * QA, mostly so QA can prove it does not talk to any server.
 */

import { renderPostBox, renderThread } from "./render";
import { queueStats, processQueue, classify } from "./moderation";
import { STRINGS, tableFor, t } from "./strings";
import { buildDigest, cadenceFor, shadowSend } from "./push";
import { isSettled, REACTION_META, SETTLEMENT_THRESHOLD, tally, weighted } from "./reactions";

export const comments = {
  renderThread,
  renderPostBox,
  queueStats,
  processQueue,
  classify,
  tables: STRINGS,
  tableFor,
  t,
  push: { buildDigest, cadenceFor, shadowSend },
  reactions: { tally, weighted, isSettled, meta: REACTION_META, SETTLEMENT_THRESHOLD },
};

declare global {
  interface Window {
    __wire?: {
      comments?: typeof comments;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.comments = comments;

  const boot = () => {
    for (const mount of Array.from(document.querySelectorAll<HTMLElement>("[data-comments-for]"))) {
      const story = mount.dataset.commentsFor as string;
      renderThread(mount, story);
    }
    for (const box of Array.from(document.querySelectorAll<HTMLElement>("[data-comment-box-for]"))) {
      const story = box.dataset.commentBoxFor as string;
      renderPostBox(box, story);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
}
